import { toggleIdInHouseSelector } from '@store/debugger';

export const triggerIdInHouseSelector = () => {
    toggleIdInHouseSelector();
    window.location.reload();
};
